// @ts-nocheck
import * as React from 'react';
import { getAppSettings, isNonNoodleInstance } from 'utils/privateLabel/index';
import type { CompleteFooterProps } from './CompleteFooter.type';
import { Wrapper, Content, LinksContainer, Column, Row, Company } from './CompleteFooter.styles';
import RenderList from './components/RenderList';
import RenderSocialIcons from './components/RenderSocialIcons';
import RenderCopyrightSection from './components/RenderCopyrightSection';

const CompleteFooter = ({ className }: CompleteFooterProps): React.ReactElement<any> | null => {
  // Even though private labels will have a separate anonymous home page we still want to handle this use case so the
  // app doesn't crash and since things may change
  if (isNonNoodleInstance) {
    return null;
  }

  const { footer } = getAppSettings();

  const { students, schools = {}, company, trending } = footer;
  return (
    <Wrapper
      className={className}
      data-testid='complete-footer'
      role='contentinfo'
      aria-label='Footer area'
    >
      <Content>
        <LinksContainer>
          <div role='list'>
            <RenderList role='listitem' itemList={students} />
          </div>
          <Column role='list'>
            <RenderList role='listitem' itemList={schools} />
            <Company role='list'>
              <RenderList role='listitem' itemList={company} />
            </Company>
          </Column>
          <div role='list'>
            <RenderList role='listitem' itemList={trending} />
          </div>
        </LinksContainer>
        <div role='list' aria-label='Our social media channels'>
          <RenderSocialIcons role='listitem' />
        </div>
        <Row role='list' aria-label='Copyright section'>
          <RenderCopyrightSection role='listitem' />
        </Row>
      </Content>
    </Wrapper>
  );
};

export default CompleteFooter;
